import { render, staticRenderFns } from "./ShopEdit.vue?vue&type=template&id=068cdb73&scoped=true&"
import script from "./ShopEdit.vue?vue&type=script&lang=js&"
export * from "./ShopEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShopEdit.vue?vue&type=style&index=0&id=068cdb73&scoped=true&lang=css&"
import style1 from "./ShopEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068cdb73",
  null
  
)

export default component.exports